
export class BewerbRunde {
    constructor(bewerbRunde, id, bewerbSettings) {
        this.id = id ? id : bewerbRunde?.id
        this.settings = {
            name: bewerbRunde?.settings?.name ?? null,
            anzahlStarterMax: bewerbSettings?.anzahlStarterMax ?? null,
            modus: bewerbSettings?.modus ?? null,
            bewerbTyp: bewerbSettings?.bewerbTyp ?? null,
        }
    }

    showAddTeamButton(){
        return this.settings.modus==='tabelle'
    }

    isDeleteable(numberOfRunden){
        return this.settings.modus==='tabelle' && this.id > 10 && numberOfRunden*10 === this.id
    }

    isOpenForAddRound(numberOfRunden){
        return this.settings.modus==='tabelle' && numberOfRunden*10 === this.id
    }

    tabNameIsChangeable(numberOfRunden){
        return this.settings.modus==='tabelle' && numberOfRunden > 1
    }
}
